import consts from "@/consts.js";
import Request from './request';

async function fetch(data) {
    return Request('get', "api/logistics", data);
}

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/logistics", data);
}

async function add(data) {
    return Request('post', "api/logistics/add", data);
}

async function edit(data) {
    return Request('post', "api/logistics/edit" , data);
}

async function Delete(id) {
    return Request('get', "api/logistics/delete/" + id);
}

async function trackByDistribution(data) {
    return Request('post', "api/logistics/track-by-distribution", data);
}

export default {
    fetch, 
    fetchAll,
    add,
    edit,
    Delete,
    trackByDistribution,
};